export const APPOINTMENT_TYPE = {
  NEW: 'new',
  REVIEW: 'review',
};

export const STATUS = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  PENDING: 'pending',
  DEFAULT: 'default',
};

export const ACTIVITY_TYPE = {
  CANCEL: 'cancel',
  POSTPONE: 'postpone',
  CONFIRM: 'confirm',
};
